<template>
<div>
    <div class="display-flex full-width timer-container" @click="expanded = !expanded" v-show="mySheet">
        <div>
            <v-icon style="font-size:20px" color="grey">timer</v-icon>
        </div>
        <div class="timer-text">
            Today: {{durationToday}}. Total {{durationTotal}}
            <span v-if="paused">(Paused)</span>
        </div>    
        <v-btn icon small>
            <v-icon small color="grey">keyboard_arrow_down</v-icon>
        </v-btn>
    </div>

    <div v-if="expanded" class="expanded-section">
        <table>
        <tr v-for="sheet in sheets" :key="sheet._id">
            <td>
                {{sheet.userName}}
            </td>
            <td align="right">
                {{duration(sheet.total)}}
            </td>
        </tr>
        
        <tr>
             <td>
                 Total Time
            </td>
            <td align="right">
                {{duration(allUserTotal)}}
            </td>           
        </tr>

        </table>
    </div>

</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import {isSameDay, subDays} from 'date-fns'
import DateHelpers from '../helpers/DateHelpers'
import Firestore from '@/data/Firestore'
import NumberHelpers from '../helpers/NumberHelpers'
import ContactHelpers from '../helpers/ContactHelpers'
import Db from '@/data/Db'

export default {
    data() {
        return {
            paused: false,
            sheets: [],
            interval: null,
            inactiveTime: 0,
            expanded: false,
        }
    },

    components: {
        
    },
    
    props: {
        relatedId: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
            default: 'Loading',
        },
        payload: {
            type: Object,
        }
    },

    computed: {
        mySheet() {
            return this.sheets.find(o => o.userId == this.myUserId)
        },

        myTimeToday() {
            if(!this.mySheet)
                return null
            return this.mySheet.days.find(d => isSameDay(d.day, new Date()))
        },

        myUserId() {
            return DataHelpers.getUserId()
        },

        myUserName() {
            return ContactHelpers.fullName(DataHelpers.getUser())
        },

        durationToday() {
            if(!this.myTimeToday)
                return 0

            return DateHelpers.convertToDuration(this.myTimeToday.seconds)
        },
        durationTotal() {
            if(!this.mySheet)
                return 0

            return this.duration(this.mySheet.total)
        },

        allUserTotal() {
            return this.sheets.reduce( (acc, val) => { return acc + val.total}, 0)
        }

    },

    methods: {

        duration(seconds) {
            return DateHelpers.convertToDuration(seconds)
        },

        debugMe() {
            console.log('My Sheet...', this.mySheet)
        },

        incrementTimer() {
            if(!this.paused) {
                this.$set(this.myTimeToday, 'seconds', this.myTimeToday.seconds + 1)
                this.$set(this.mySheet, 'total', this.mySheet.total + 1)

            }
        },

        incrementInactive() {
            this.$set(this, 'inactiveTime', this.inactiveTime + 1)
        },

        keepAlive() {
            this.inactiveTime = 0
        },

        saveTimesheet() {
            const sheet = Object.assign(this.mySheet, this.payload)
            this.mySheet.title = this.title
            this.mySheet._db.saveItem(this.mySheet, {owner: true, timestamp: true})
        },

   
    },

    async created() {
        console.log('Time tracker created...')

        window.addEventListener('click', this.keepAlive)
        window.addEventListener('keypress', this.keepAlive)

        const db = new Db()
        let sheets = await db.ref('timesheets').where('relatedId', '==', this.relatedId).fetch()

        if(sheets.length)
            this.sheets = sheets

        //create first sheet for me...
        if(!this.mySheet) {
            const sheet = {}
            sheet._db = db
            sheet._id = Firestore.getId()

            //todo: remove....
            sheet.flowId = this.relatedId

            sheet.relatedId = this.relatedId
            sheet.userId = this.myUserId
            sheet.userName = this.myUserName
            sheet.total = 0
            sheet.days = []
            this.sheets.push(sheet)
        }

        //add new day to my sheet...
        if(!this.myTimeToday) {
            this.mySheet.days.push({
                day: new Date(),
                seconds: 0,
            })
        }
    
        setInterval(this.incrementInactive, 1000)
        setInterval(this.incrementTimer, 1000)
    },

    beforeDestroy() {
        window.removeEventListener('click', this.keepAlive)
        window.removeEventListener('keypress', this.keepAlive)
        this.saveTimesheet()
    },

    watch: {
        'inactiveTime': {
            handler: function(newVal) {
                if(newVal > 60)
                    this.paused = true
                else
                    this.paused = false
            }
        }
    }
}
</script>

<style scoped>
.timer-text {
    padding:2px;
    flex-grow:1
}
.timer-container {
    cursor: pointer;
    font-size:14px;
    color: #888;
    /* background-color: rgba(0,0,0,0.1);
    border-radius: 999px; */
    /* padding: 2px 5px; */
}

.expanded-section {
    padding: 10px;
    font-size: 14px;
    color: #999;
}
</style>




// WEBPACK FOOTER //
// TimeTracker.vue?df70c326